export enum AnalysisStatus {
    PENDING = 'Pending',
    ERROR = 'Error',
    COMPLETED = 'Finished',
}

export enum EnvironmentalRiskCategory {
    VERY_LOW = 'Negligible risk',
    LOW = 'Low',
    MEDIUM = 'Moderate risk',
    HIGH = 'High',
    SEVERE = 'Severe',
    EXTREME = 'Extreme',
}

export const SampleProjectId = "297d187b-1c53-44a6-a709-2bae1ce81599";

// Project gated to the Client Data Room feature (Tata Motors) for now.
// Must match backend settings.TATA_PROJECT_ID.
export const TataProjectId = "037c1a12-af0b-48c3-8b36-9d2b3303367c";

export const AllowedDataRoomProjectIds = [
  "037c1a12-af0b-48c3-8b36-9d2b3303367c",
  "1656b030-6b7a-4ec5-ad3b-5132e3e97f8c",
];